export default __webpack_public_path__ + "static/media/box-5Open.574bcbfa.jpg";